export const PATResultConstants = {
  PASS: 'Pass',
  FAIL: 'Fail',

}
